import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import * as qs from 'app/lib/helperjs';
import {RegisterType} from 'app/components/sign/registration/registerType';
import {RegisterContainer as Registration} from 'app/components/sign/registration/registration';
import {registerModalPropsResolver} from './registerModalPropsResolver';
import {gtmEventPusher} from 'app/services/gtmEventPusher';
import {GTM_EVENTS} from 'app/model/gtmEvents';

const MODAL_TRIGGER_SELECTOR = '.js-registration-modal-open';

const Modal = ({registerTab = RegisterType.INDIVIDUAL, calculatorInProgress = false}) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        const triggers = qs.querySelectorAll(MODAL_TRIGGER_SELECTOR);

        if (!calculatorInProgress) {
            qs.removeEventListener(triggers, 'click', triggerClickHandler);
            qs.addEventListener(triggers, 'click', triggerClickHandler);
        }
    }, [calculatorInProgress]);

    useEffect(() => {
        window.registerModalApplied = dialogOpen;
    }, [dialogOpen]);

    const triggerClickHandler = (evt) => {
        evt.preventDefault();
        setDialogOpen(true);
        gtmEventPusher(GTM_EVENTS.MODAL);
    };

    return (
        <Dialog
            classes={{
                container: 'form-modal-container',
                paper: 'form-modal-body',
            }}
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}>
            <button type="button" onClick={() => setDialogOpen(false)} className="modal-dismiss">
                <i className="fas fa-times"/>
            </button>
            <Registration showLoader={false} tab={registerTab} forwardReferer={false}/>
        </Dialog>
    );
};
Modal.propTypes = () => ({
    registerTab: PropTypes.oneOf([RegisterType.INDIVIDUAL, RegisterType.BUSINESS]),
    calculatorInProgress: PropTypes.bool,
});

export const RegisterModal = connect(registerModalPropsResolver)(Modal);
